import React, { ReactNode } from "react";
import { Popover, Stack } from "react-bootstrap";
import { ContactsLabel, TimingLabel } from "../../shared/enums/labels.enums";
import { parsePhaseName } from "../../shared/enums/phases.enums";
import { isNullOrUndefined } from "../../shared/utils/data.utils";
import BADGE from "../badge/Badge.component";
import CardUtils from "../card/Card.utils";
import ToolTipStyles from "./ToolTip.styles";
import { DefaultToolTipProps, IToolTipProps } from "./ToolTip.types";
import {
  ContactsMessageMap,
  getBadgeTooltipMessage,
  PhaseNameMessageMap,
  TimingMessageMap,
} from "./ToolTip.utils";

const renderPhaseNameMessage = (phaseName: string): ReactNode => {
  const phaseNameKey = parsePhaseName(phaseName, true) ?? undefined;

  if (isNullOrUndefined(phaseNameKey)) {
    return "";
  }

  return PhaseNameMessageMap[phaseNameKey];
};

const renderHeaderLabel = (
  packageStatus: string | undefined,
  phaseName: string | undefined,
  timingLabel: TimingLabel | undefined,
  contactsLabel: ContactsLabel | undefined
): React.ReactNode => {
  if (!isNullOrUndefined(packageStatus)) {
    return "Package Status";
  } else if (!isNullOrUndefined(phaseName)) {
    return phaseName;
  } else if (!isNullOrUndefined(timingLabel)) {
    return timingLabel;
  } else if (!isNullOrUndefined(contactsLabel)) {
    return contactsLabel;
  } else {
    return "";
  }
};

const TOOL_TIP = (props: IToolTipProps) => {
  const { packageStatus, phaseName, timingLabel, contactsLabel } = props;
  const badgeData = CardUtils.getBadgeFormat(packageStatus ?? "");

  return (
    <ToolTipStyles.ToolTip className="tool-tip" data-testid="tooltip-component">
      <Popover.Header as="h3">
        {renderHeaderLabel(
          packageStatus,
          phaseName,
          timingLabel,
          contactsLabel
        )}
      </Popover.Header>
      <Popover.Body>
        {!isNullOrUndefined(badgeData) && badgeData.label.length > 0 && (
          <Stack direction="vertical" gap={2} data-testid="badge-stack">
            <BADGE bg={badgeData.colorFlag}>{badgeData.label}</BADGE>
            <p data-testid="badge-message">
              {getBadgeTooltipMessage(badgeData.label)}
            </p>
          </Stack>
        )}
        {!isNullOrUndefined(phaseName) && phaseName.length > 0 && (
          <p data-testid="phase-name">{renderPhaseNameMessage(phaseName)}</p>
        )}
        {!isNullOrUndefined(timingLabel) && timingLabel.length > 0 && (
          <p data-testid="timing-message">{TimingMessageMap[timingLabel]}</p>
        )}
        {!isNullOrUndefined(contactsLabel) && contactsLabel.length > 0 && (
          <p data-testid="contacts-message">
            {ContactsMessageMap[contactsLabel]}
          </p>
        )}
      </Popover.Body>
    </ToolTipStyles.ToolTip>
  );
};

TOOL_TIP.defaultProps = DefaultToolTipProps;
export default TOOL_TIP;
